/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cloud_logic_custom": [
        {
            "name": "authendpoint",
            "endpoint": "https://ivlov1pd42.execute-api.eu-west-1.amazonaws.com/test",
            "region": "eu-west-1"
        },
        {
            "name": "drupalProxy",
            "endpoint": "https://6x04n1ajn9.execute-api.eu-west-1.amazonaws.com/test",
            "region": "eu-west-1"
        },
        {
            "name": "mobile",
            "endpoint": "https://8atbju1ov9.execute-api.eu-west-1.amazonaws.com/test",
            "region": "eu-west-1"
        },
        {
            "name": "salesforceauth",
            "endpoint": "https://7pg1roi26b.execute-api.eu-west-1.amazonaws.com/test",
            "region": "eu-west-1"
        },
        {
            "name": "sdmAgendaApi",
            "endpoint": "https://5gu7qd1x8l.execute-api.eu-west-1.amazonaws.com/test",
            "region": "eu-west-1"
        },
        {
            "name": "sdmAppointmentApi",
            "endpoint": "https://9mmn2uust8.execute-api.eu-west-1.amazonaws.com/test",
            "region": "eu-west-1"
        },
        {
            "name": "sdmAzureApi",
            "endpoint": "https://xirhug2510.execute-api.eu-west-1.amazonaws.com/test",
            "region": "eu-west-1"
        },
        {
            "name": "sdmBrSettingsApi",
            "endpoint": "https://cbnzbkenc8.execute-api.eu-west-1.amazonaws.com/test",
            "region": "eu-west-1"
        },
        {
            "name": "sdmPubNub",
            "endpoint": "https://7wj7unwjkh.execute-api.eu-west-1.amazonaws.com/test",
            "region": "eu-west-1"
        },
        {
            "name": "sdmStripeApi",
            "endpoint": "https://ch8jk1txt6.execute-api.eu-west-1.amazonaws.com/test",
            "region": "eu-west-1"
        },
        {
            "name": "sdmVirtualEventModeratorApi",
            "endpoint": "https://69uzjly6a5.execute-api.eu-west-1.amazonaws.com/test",
            "region": "eu-west-1"
        },
        {
            "name": "virtualEventInterface",
            "endpoint": "https://40ov86pitf.execute-api.eu-west-1.amazonaws.com/test",
            "region": "eu-west-1"
        },
        {
            "name": "vonageServer",
            "endpoint": "https://s68zcd9xv3.execute-api.eu-west-1.amazonaws.com/test",
            "region": "eu-west-1"
        },
        {
            "name": "webinarInteraction",
            "endpoint": "https://60g5bn0tj0.execute-api.eu-west-1.amazonaws.com/test",
            "region": "eu-west-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://4twekw3uovev5hu6wglawb65mm.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-1",
    "aws_appsync_authenticationType": "AWS_IAM"
};


export default awsmobile;
